import _ from 'lodash';
import buildParams from "utilities/request/buildParams";
import convert from "utilities/request/convert";
import { foodWriteBarrier, withFoodBudget } from "../redux/food/foodRequests";



function runRequest(url, data = null, method = 'GET') {
	const headers = {
		'Accept': 'application/json',
	};
	const dataToSend = {
		headers: headers,
		method,
	};
	url = new URL(url);
	let urlParams = null;
	if(data) {
		for(let key in data) {
			if(!data.hasOwnProperty(key)) {
				continue;
			}
			if(data[key] === undefined) {
				continue;
			}
			if(!urlParams) {
				urlParams = {};
			}
			urlParams[key] = data[key];
		}
	}
	if(method === 'GET') {
		delete dataToSend.body;
		if(urlParams) {
			url.search = new URLSearchParams(urlParams).toString();
		}
	} else {
		if(urlParams) {
			dataToSend.body = convert(urlParams);
			// console.log('converted', dataToSend.body);
			headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
		}

	}

	return fetch(url, dataToSend)
		.then(async(response) => {
			if(response.ok) {
				return response.json();
			} else {
				console.log('Got an error response!', response);
				// Callers read the server's message from responseJSON. Parse a clone, so a caller that
				// reads the body itself (Request.parseError) still can.
				try {
					response.responseJSON = await response.clone().json();
				} catch(error) {
					response.responseJSON = null;
				}
				return Promise.reject(response);
			}
		});
}

export default class Request {
	static siteUrl = null;

	static getSiteUrl() {
		if(this.siteUrl) {
			return this.siteUrl;
		}
		if(typeof siteUrl !== 'undefined') {
			return siteUrl;
		}
		throw new Error('Uh oh, no siteUrl found');
	}

	static generalSend(data, url, callback, errorCallback, method = 'POST') {
		let request = runRequest(url, data, method);
		request.then((response) => {
			if(callback) {
				var result = callback(response);
				if(result === true) {
					// require('components/Dashboard').Dashboard.performOpenSearchUpdate(response);
				}
			}
			return response;
		}, function() {
			if(callback) {
				callback({ success: false, serverError: true });
			}
			if(errorCallback) {
				errorCallback();
			}
		});
		return request;
	}

	static get(url, data, callback) {
		return Request.generalSend(data, url, callback, null, 'GET');
	}

	static post(url, data, callback) {
		return Request.generalSend(data, url, callback, null, 'POST');
	}


	static api(data, action, callback, errorCallback) {
		return Request.generalSend(data, Request.getSiteUrl() + '/apiv1/' + action, callback, errorCallback);
	}

	static apiv1GetFromCache(action, data) {
		const query = _.isEmpty(data) ? '' : `?${$.param(data)}`;
		const cacheUrlToCheck = `${Request.getSiteUrl()}/api/v1/${action}${query}`;
		console.log('hi?!');
		if(true || window.caches === undefined) {
			return Request.apiv1Get(action, data);
		}
		return caches.match(cacheUrlToCheck)
			.then((response) => {
				if(!response) {
					console.log('response was', response);
					throw new Error('No Cache Data ' + cacheUrlToCheck);
				}
				return response.json();
			})
			.catch((cacheError) => {
				console.log('cache error url', action);
				console.error(cacheError);
				throw new Error(cacheError);
			});
	}

	static apiv1GetFromCacheThenRequestForLater(action, data) {
		let didNormalRequest = false;
		const cacheRequestFinished = () => {
			didNormalRequest = true;
			return Request.apiv1Get(action, data)
				.then((response) => {
					// console.log('got update!');
					return response;
				});
		};
		return Request.apiv1Get(action, data);

		return Request.apiv1GetFromCache(action, data)
			.catch(() => {
				console.log('cache failed, attempting regular request');
				return cacheRequestFinished();
			})
			.then((response) => {
				if(didNormalRequest) {
					console.log('returning response from fresh api fetch', response);
					return response;
				} else {
					cacheRequestFinished();
					console.log('returning cache result', response);
					return response;
				}
			})
			.catch((error) => {
				console.error('Everything failed, cache failed, repsonse failed!');
				throw error;
			});
	}

	/** A legacy food endpoint is sent the budget the page is showing; see redux/food/foodRequests.js. */
	static apiv1Get(action, data, callback) {
		return Request.get(Request.getSiteUrl() + '/api/v1/' + action, withFoodBudget(action, data), callback);
	}

	/**
	 * A legacy food write first waits for the budget's queued ops to be sent; see foodRequests.js. It
	 * names the budget shown when it was made, so after a switch meanwhile the server refuses it.
	 */
	static apiv1Post(action, data, callback) {
		const sent = withFoodBudget(action, data);
		const post = () => Request.post(Request.getSiteUrl() + '/api/v1/' + action, sent, callback);
		const barrier = foodWriteBarrier(action);
		return barrier ? barrier.then(post) : post();
	}

	static apiv1PostFile(action, data) {
		const formData = new FormData();
		_.each(data, (value, key) => {
			formData.append(key, value);
		});
		let wasOk = false;
		return fetch(`${Request.getSiteUrl()}/api/v1/${action}`,
			{
				method: 'POST',
				body: formData
			}
		)
			.then((response) => {
				if(response.ok) {
					wasOk = true;
				}
				return response.json();
			})
			.then((json) => {
				if(wasOk) {
					return json;
				}
				json.responseJSON = { ...json };
				return Promise.reject(json);
			});
	}

	static send(data, action, callback, errorCallback) {
		return Request.generalSend(data, Request.getSiteUrl() + '/matchmaking/' + action, callback, errorCallback);
	}

	static socket(data, callback, errorCallback) {
		// Dashboard.serverConnection.send(data);
		alert('sending?!');
	}

	static generalJsonError(response = null) {
		let error = null;
		console.error(response);
		if(!response) {
			error = 'Something went very wrong!';
			alert(error);
			return error;
		}
		if(response.responseJSON) {
			if(response.responseJSON.error) {
				error = response.responseJSON.error;
				alert(error);
				return error;
			}
		}
	}

	static async parseError(response = null) {
		let error = null;
		console.log('what is the error', response);
		if(!response) {
			error = 'Something went very wrong!';
			return error;
		}
		let json = null;
		try {
			json = await response.json();
		} catch(error) {
			console.error(error);
			return 'Something went wrong!';
		}
		if(json.error) {
			console.log('has json.error', json.error);
			return json.error;
		}
		return 'Something went wrong';
	}
}

Request.FROM_HTTP = 1;
Request.FROM_WEBSOCKET = 2;
